import { Injectable } from '@angular/core';
import { ITeamsApplicationConfigurationProvider } from '@nimbus-library/features/microsoft-teams/models/i-teams-application-configuration.provider';
import { ITeamsApplicationConfiguration } from '@nimbus-library/features/microsoft-teams/models/i-teams-application.configuration';

@Injectable()
export class TeamsApplicationConfigurationProviderFake implements ITeamsApplicationConfigurationProvider {
  public getConfiguration(): ITeamsApplicationConfiguration {
    return {
      appId: 'app-id',
    };
  }
}
